import React from 'react';
import LogoWhite from '../../../../assets/logo/logo-white.png';
import LogoDark from '../../../../assets/logo/logo-dark.png';

interface LogoProps {
  alt?: string;
  className?: string;
}

export default function Logo({ alt = 'Rollout APP', className = 'h-6 w-auto' }: LogoProps) {
  // read theme from document element — app toggles `dark` class on root
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  const src = isDark ? LogoWhite : LogoDark;

  return <img src={src} alt={alt} className={className} />;
}
